// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__LIS6L","spin":"Spinner_spin__ZlANk"};